var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pb-0",staticStyle:{"width":"100%","height":"100%","object-fit":"fill"},attrs:{"outlined":""}},[_c('img',{ref:"viewer",staticStyle:{"height":"100%","object-fit":"fill"},attrs:{"id":"stream","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }